import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router);
import VxMain from "./components/VxMain";

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '',
      name: 'home',
      props: true,
      component: VxMain
    },
    {
      path: '*',
      redirect: '/'
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      document.getElementById('myApp').scrollTop = 0
      return { x: 0, y: 0 }
    }
  }
});

export default router
